import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../orders-list/model/orders-list.constants";
import { editOrder, editPromoCode } from "./orders-edit.component.service";
import { getOrdersInputs, getPromoCodeInputs } from "../model/orders.modal";
import OrdersEditTemplateComponent from "./orders-edit.template.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  ORDER_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const OrdersEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let orderPayload = {};
    for (let i = 0; i < values.length; i++) {
      let field = values[i];

      // If this field is select → find correct numeric value
      if (field.type === "SELECT") {
        const selected = field.options.find(
          (opt) => opt.name === field.value || opt.value == field.value
        );
        orderPayload[field.name] = selected?.value;
      } else {
        orderPayload[field.name] = field.value;
      }
    }

    console.log({ orderPayload });

    // INFO : call create api
    const orderResponse = await editOrder(
      location?.state?.row?.id,
      orderPayload
    );

    // INFO : check api response and show relevant alert message
    if (orderResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: orderResponse.message })
      );
    }
  };
  console.log(location.state.row);

  const templateModal = {
    formTriggers,
    formInputs: getOrdersInputs({
      id: location?.state?.row?.id || "",
      date: location?.state?.row?.date || "",
      order_id: location?.state?.row?.order_id || "",
      company_name: location?.state?.row?.company_name || "",
      mobile: location?.state?.row?.mobile || "",
      product_count: location?.state?.row?.product_count || "",
      order_value: location?.state?.row?.order_value || "",
      status: location?.state?.row?.status || "",
      payment_status: location?.state?.row?.payment_status || "",
      order: location?.state?.row.order || "",
      billing_address: location?.state?.row?.billing_address || "",
      shipping_address: location?.state?.row?.shipping_address || "",
      
    }),
  };
  console.log({ templateModal });

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <OrdersEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default OrdersEditComponent;
